var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form__main"},[_c('ContactsTable',{attrs:{"outerFilters":_vm.outerFilters,"hideControls":"","editable":"","hideSearch":"","insideCampaign":"","campaignId":_vm.campaignId,"showSelect":false,"insideModal":_vm.isModal,"teamFilterOff":_vm.teamFilterOff}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }